<template>
    <div>
        <p :class="titleClasses" class="text-primary font-semibold text-xl"> {{title}}</p>
        <p :class="descriptionClasses" class="py-2" v-html="description"></p>
    </div>
</template>

<script>
export default {
    props:{
        title: String,
        description: String,
        titleClasses: String,
        descriptionClasses: String,
    }
}
</script>
